import React from 'react'

import { CollapsableCard, Dimensions, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { CollapsableCardHeader } from '../CollapsableCardHeader'

type Props = {
  title: string
  description?: string
  defaultOpen?: boolean
  infoTooltipLabel?: string
  disabled?: boolean
  contentPadding?: Dimensions
  cbk?: () => void
}

const CollapsableSection = ({
  title,
  description,
  defaultOpen,
  children,
  infoTooltipLabel,
  disabled = false,
  contentPadding = 's24',
  cbk,
}: React.PropsWithChildren<Props>) => {
  const [collapsableOpen, setCollapsableOpen] = React.useState(!!defaultOpen)

  const toggleCollapsableOpen = () => {
    setCollapsableOpen((currentCollapsableOpen) => !currentCollapsableOpen)
    if (cbk) cbk()
  }

  return (
    <CollapsableCard
      open={collapsableOpen}
      contentBackground="grey000White"
      contentPadding={contentPadding}
      Card={
        <CollapsableCardHeader
          showDescription={collapsableOpen}
          title={title}
          description={description}
          disabled={disabled}
          infoTooltipLabel={infoTooltipLabel}
        >
          <TogglerCheckbox
            value={collapsableOpen}
            onChange={toggleCollapsableOpen}
            disabled={disabled}
          />
        </CollapsableCardHeader>
      }
      Content={children}
    />
  )
}

export default CollapsableSection
